export default "__VITE_ASSET__df34dedd__"